// extracted by mini-css-extract-plugin
export default {"tabBar":"style_tabBar__mV3hn","tabBarNav":"style_tabBarNav__3mbT8","tabBarLink":"style_tabBarLink__hKvpM","TabBarLink":"style_TabBarLink__D-ykz"};